var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.791687 1.79166H18.2084M3.95835 1.79166V5.74999C3.95835 8.12499 7.91669 8.31103 7.91669 10.5C7.91669 12.6889 3.95835 12.875 3.95835 15.25V19.2083M15.0417 1.79166V5.74999C15.0417 8.12499 11.0834 8.31103 11.0834 10.5C11.0834 12.6889 15.0417 12.875 15.0417 15.25V19.2083M0.791687 19.2083H18.2084M7.91669 4.56249H11.0834V5.74999C11.0834 6.54166 9.50002 7.33332 9.50002 7.33332C9.50002 7.33332 7.91669 6.54166 7.91669 5.74999V4.56249ZM6.33335 17.625C6.33335 16.0417 9.50002 14.4583 9.50002 14.4583C9.50002 14.4583 12.6667 16.0417 12.6667 17.625V19.2083H6.33335V17.625Z",
    stroke: "url(#paint0_linear_1_73)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_73",
    x1: 9.50002,
    y1: 1.79166,
    x2: 9.50002,
    y2: 19.2083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3612C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A095D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInProgress);
export default __webpack_public_path__ + "static/media/IconInProgress.ce24302bf4f7945beb11b02c9c47211f.svg";
export { ForwardRef as ReactComponent };